import { ComponentProps } from "react";
import { IComponentParent } from "sonobello.utilities.react";

import { ProtectedAppContextProvider } from "../../../AppContext";
import NewPatientFlow from "../../Types/NewPatientFlow";
import NoBookFlow from "../../Types/NoBookFlow";
import RebookFlow from "../../Types/RebookFlow";
import ExperimentAssignmentAppContextProvider, {
  IExperimentAssignmentAppContextProviderProps
} from "../Components/ExperimentAssignmentAppContextProvider";
import useCreatePatientExperimentManualAuth from "../Hooks/UseCreatePatientExperiment";
import NameMatchFlowResolver from "../Types/NameMatchFlowResolver";
import NoConfirmationNewPatientFlow from "../Types/NoConfirmationNewPatientFlow";
import NoConfirmationNoBookFlow from "../Types/NoConfirmationNoBookFlow";
import NoConfirmationRebookFlow from "../Types/NoConfirmationRebookFlow";
import NoWelcomeNoBookFlow from "../Types/NoWelcomeNoBookFlow";
import NoWelcomeRebookFlow from "../Types/NoWelcomeRebookFlow";
import ExperimentContextValueProvider from "./ExperimentContextValueProvider";

const configuredExperimentAssignmentAppContextProvider: React.FC<
  IExperimentAssignmentAppContextProviderProps
> = props =>
  ExperimentAssignmentAppContextProvider({
    ...props,
    flowResolver: new NameMatchFlowResolver([
      new NoConfirmationNewPatientFlow(props.session.patient.isPreviouslyQualified),
      new NoConfirmationRebookFlow(props.session.patient.isPreviouslyQualified),
      new NoConfirmationNoBookFlow(props.session.patient.isPreviouslyQualified),
      new NewPatientFlow(props.session.patient.isPreviouslyQualified),
      new RebookFlow(props.session.patient.isPreviouslyQualified),
      new NoBookFlow(props.session.patient.isPreviouslyQualified),
      new NoWelcomeNoBookFlow(props.session.patient.isPreviouslyQualified),
      new NoWelcomeRebookFlow(props.session.patient.isPreviouslyQualified)
    ]),
    useCreatePatientExperiment: useCreatePatientExperimentManualAuth,
    AppContext: ProtectedAppContextProvider
  });

const ExperimentContextAppContextProvider: React.FC<
  IComponentParent & Omit<IExperimentAssignmentAppContextProviderProps, "experimentContextProps">
> = ExperimentContextValueProvider<
  Pick<IExperimentAssignmentAppContextProviderProps, "experimentContextProps">,
  ComponentProps<typeof configuredExperimentAssignmentAppContextProvider>
>({
  Component: configuredExperimentAssignmentAppContextProvider,
  map: experimentContextProps => ({ experimentContextProps })
});

export default ExperimentContextAppContextProvider;
